import { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { AlertCircle, Loader2, FileCheck, CheckCircle2, MailCheck } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      if (!token) { setStatus("error"); setMessage("This verification link is invalid or incomplete."); return; }
      try {
        const { data } = await axios.post(`${API_URL}/api/auth/verify-email`, { token });
        setStatus("success");
        setMessage(data.message || "Your email has been verified.");
      } catch (err) {
        const d = err.response?.data?.detail;
        setStatus("error");
        setMessage(typeof d === "string" ? d : "Verification failed. Please request a new link.");
      }
    })();
  }, [token]);

  return (
    <div className="auth-page" data-testid="verify-email-page">
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" className="auth-logo-link">
            <div className="lp-logo-icon"><FileCheck size={16} /></div>
            <span className="auth-logo">ResumeAI</span>
          </Link>
          <h1>Email verification</h1>
        </div>

        <div className="auth-form" style={{ alignItems: "center", textAlign: "center", gap: 16, padding: "8px 0" }}>
          {status === "verifying" && (
            <div data-testid="verify-loading" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
              <Loader2 size={40} className="spin" style={{ color: "var(--primary)" }} />
              <p style={{ color: "var(--text-secondary)", margin: 0 }}>Verifying your email…</p>
            </div>
          )}
          {status === "success" && (
            <div data-testid="verify-success" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
              <CheckCircle2 size={48} style={{ color: "#10b981" }} />
              <p style={{ color: "var(--text-primary)", fontWeight: 600, margin: 0 }}>{message}</p>
            </div>
          )}
          {status === "error" && (
            <div data-testid="verify-error" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
              <AlertCircle size={48} style={{ color: "#ef4444" }} />
              <p style={{ color: "var(--text-secondary)", margin: 0 }}>{message}</p>
            </div>
          )}
          <Link to="/app" className="auth-btn" data-testid="verify-goto-app" style={{ textDecoration: "none", width: "100%" }}>
            <MailCheck size={16} /> Continue to ResumeAI
          </Link>
        </div>

        <div className="auth-footer">
          <Link to="/login" data-testid="verify-back-to-login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
